module.exports = function removeTags(str) {
    if ((str===null) || (str==='')) 
        return false; 
    else
        str = str.toString(); 
    return str.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/g, ' '); 
}
